<template>
  <div>
    <v-autocomplete
      :items="items"
      v-model="selectedPlace"
      :label="label"
      item-text="name"
      item-value="id"
      @change="onChange"
      :outlined="outlined"
      :hide-details="hideDetails"
      :dense="dense"
    ></v-autocomplete>
    <div v-if="debug">
      <code>{{ items }}</code>
      <code>{{ selectedPlace }}</code>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename, uniqueByProp } from "../../../helpers";
const THOMPSONS_PLACES_QUERY = gql`
  query thompsonsPlaces($filter: ThirdPartyMappingFilterType) {
    thompsonsPlaces: thirdPartyMappings(filter: $filter) {
      edges {
        node {
          id
          remoteUid
          matchDetails
        }
      }
    }
  }
`;

export default {
  name: "thompsons-place-list-select",
  props: {
    label: {
      type: String,
      default: () => "Place",
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    destinationId: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      debug: false,
      selectedPlace: this.value ? this.value : "",
    };
  },
  computed: {
    items() {
      if (this.thompsonsPlaces && this.thompsonsPlaces.edges.length > 0) {
        const items = this.thompsonsPlaces.edges
          .map(removeGQLTypename)
          .map((item) => ({
            id: item.remoteUid,
            name: JSON.parse(item.matchDetails).source,
          }));
        return uniqueByProp(items, "name");
      } else {
        return [];
      }
    },
  },
  watch: {
    value(newVal) {
      this.selectedPlace = newVal ? newVal : "";
    },
  },
  methods: {
    onChange(event) {
      this.$emit("input", this.selectedPlace);
    },
  },
  apollo: {
    thompsonsPlaces: {
      query: THOMPSONS_PLACES_QUERY,
      variables() {
        return {
          filter: {
            vendor_eq: "ThompsonsAfrica",
            destination_id_eq: this.destinationId,
          },
        };
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/ThompsonsPlaceListSelect.vue